import { EN_SOLUTION_BUSINESS_TYPE } from '@do-lib/global-config-2d';
import { getStandardBranchManager } from '../core/factory';
import { DefaultRegistry } from './default_registry';
import { EN_SERVICE_PLUGIN_SYMBOL } from '../core';
import { IUIUserConfig } from '../plugins/service_plugins/ui_config/interface/interface';

interface IPluginConfigRegister {
  register(): Promise<void>;
  registerCad(): Promise<void>;
  registerCatia(): Promise<void>;
  registerSolidWorks(): Promise<void>;
  registerNX(): Promise<void>;
}

const sbMap = new Map<string, IPluginConfigRegister>();
const tenantMap = new Map<string, IPluginConfigRegister>();
export const registerSbConfig = (sbName: string) => {
  return (clazz: IPluginConfigRegister): void => {
    sbMap.set(sbName, clazz);
  };
};

export const registerTenantConfig = (tenantName: string) => {
  return (clazz: IPluginConfigRegister): void => {
    tenantMap.set(tenantName, clazz);
  };
};

// 加载插件
export const loadPlugins = async (): Promise<void> => {
  const manager = getStandardBranchManager();
  const { standardBranchName, tenantName, clear, solutionBusinessType } = manager;
  clear();

  let tenantConfig = tenantMap.get(tenantName);
  const sbConfig = sbMap.get(standardBranchName);

  if (!tenantConfig) {
    console.error(`${solutionBusinessType},${tenantName}租户未创建config`);
    tenantConfig = DefaultRegistry;
  }

  if (!sbConfig) {
    console.error(`${solutionBusinessType},${standardBranchName}品系未创建config`);
  }

  const registerByBusinessType = async (config: IPluginConfigRegister) => {
    await config.register();
    switch (solutionBusinessType) {
      case EN_SOLUTION_BUSINESS_TYPE.CAD:
        await config.registerCad();
        break;
      case EN_SOLUTION_BUSINESS_TYPE.CATIA:
        await config.registerCatia();
        break;
      case EN_SOLUTION_BUSINESS_TYPE.SOLIDWORKS:
        await config.registerSolidWorks();
        break;
      case EN_SOLUTION_BUSINESS_TYPE.NX:
        await config.registerNX();
        break;
      default:
        break;
    }
  };

  await registerByBusinessType(tenantConfig);
  if (sbConfig) {
    await registerByBusinessType(sbConfig);
  }

  await executionAfterLoadPlugins();
};

const executionAfterLoadPlugins = async () => {
  const manager = getStandardBranchManager();
  const { servicePluginManager } = manager;
  await servicePluginManager.execute<null, IUIUserConfig>(EN_SERVICE_PLUGIN_SYMBOL.UI_CONFIG);
};
